import { graphql } from '../../graphql';

export const getStaticPage = graphql(`
  query GetStaticPage($slug: PageSlugEnum!) {
    page(slug: $slug) {
      id
      slug
      title
      content
    }
  }
`);
